export const WA_NUMBER = "4917641800480";
export const PHONE_DISPLAY = "+49 176 41 800 480";
export const EMAIL = "n.rafiq-arli@web.de";
export const ADDRESS = "Traute-Lafrenz-Straße 161, 22297 Hamburg";

export const waLink = (message) =>
  `https://wa.me/${WA_NUMBER}?text=${encodeURIComponent(message)}`;

export const IMAGES = {
  logo: "/images/logo.png",
  portrait: "/images/hafencity.webp",
  hafencity: "/images/hafencity.webp",
  heroBg: "/images/hero-bg.webp",
  heroBgWide: "/images/hero-bg-wide.webp",
  room: "/images/praxis-raum.webp",
  certificates: "/images/praxis-zertifikate.webp",
};

export const TOPIC_ORDER = [
  "trauma",
  "angst",
  "depression",
  "selbstwert",
  "gewicht",
  "rauchen",
  "trauer",
  "paartherapie",
  "beispiele",
];

export const METHOD_ORDER = [
  "hypnose",
  "havening",
  "gespraechstherapie",
  "kultursensibel",
  "thetahealing",
  "beratung",
  "coaching",
  "lebensstil",
];

export const pad = (n) => String(n).padStart(2, "0");
